import { em as emFactory } from '../../next-schema/generated/markTypes';

/**
 * @name em_mark
 */

var emDOM = ['em'];
export var em = emFactory({
  parseDOM: [{
    tag: 'i'
  }, {
    tag: 'em'
  }, {
    style: 'font-style=italic'
  }],
  toDOM: function toDOM() {
    return emDOM;
  }
});